import {Header, Layout} from "@components/common";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {fetchJson, getShopNavigation, redirectTo404Page} from "../index";
import {useState} from "react";
import {Button} from "@components/ui";
import s from "../news/news.module.scss";
import Image from "next/image";
import Lightbox from "yet-another-react-lightbox";
import cn from "clsx";
import Link from "next/link";
import {useTranslation} from "next-i18next";
import {useRouter} from "next/router";
import CustomLightbox from "@components/CmsBlocks/CustomLightbox";



export interface Photo {
  id: string;
  owner: string;
  secret: string;
  server: string;
  description: {_content: string};
  farm: number;
  title: string;
  ispublic: number;
  isfriend: number;
  isfamily: number;
  url_sq: string;
  height_sq: number;
  width_sq: number;
  url_t: string;
  height_t: number;
  width_t: number;
  url_s: string;
  height_s: number;
  width_s: number;
  url_q: string;
  height_q: number;
  width_q: number;
  url_m: string;
  height_m: number;
  width_m: number;
  url_n: string;
  height_n: number;
  width_n: number;
  url_z: string;
  height_z: number;
  width_z: number;
  url_c: string;
  height_c: number;
  width_c: number;
  url_l: string;
  height_l: number;
  width_l: number;
  url_o: string;
  height_o: number;
  width_o: number;
}

export interface Photos {
  page: number;
  pages: number;
  perpage: number;
  total: number;
  photo: Photo[];
}

export interface Flickr {
  photos: Photos;
}


const PAGE_SIZE = 21;

export function getImages(locale: string, page: number, pageSize: number, search: string | null = null, tag = false): any {
  return new Promise(async (resolve) => {
    const apiKey = '3849884059e15ddd371a2300cb308d10';
    const method = 'flickr.photos.search';
    const userId = 'boraargon18';
    page = page ? page : 1;
    pageSize = pageSize ? pageSize : 1;
    const extras = 'url_sq,url_t,url_s,url_q,url_m,url_n,url_z,url_c,url_l,url_o,description';
    let url = 'https://api.flickr.com/services/rest/?method=' + method + '&api_key=' + apiKey + '&user_id=' + userId + '&format=json&nojsoncallback=1&page=' + page + '&per_page=' + pageSize + "&extras=" + extras + "&nojsoncallback=1";
    if (tag) {
      url += "&tags=" + tag;
    }
    if (search) {
      url += "&text=" + search;
    }
    const images: Flickr = await fetchJson(url)

    if (!images || !images.photos?.photo?.length) {
      resolve({
        images: null,
        slides: null
      });
      return;
    }

    const slides = images.photos.photo.map((image: Photo) => {
      const {
        url_c, // medium (800px)
        url_n, // small (320px)
        url_z, // medium (640px)
        url_l, // large (1024px)
        url_o, // original
        url_m, // small (240px)
        url_q, // thumbnail (150px)
        url_s, // small (75px)
        url_t, // thumbnail (100px)
        height_c,
        width_c,
        height_n,
        width_n,
        height_z,
        title,
        width_z,
        height_l,
        width_l,
        height_o,
        width_o,
        height_m,
        width_m,
        height_q,
        width_q,
        height_s,
        width_s,
        height_t,
        width_t,
        description
      } = image;

      const obj: any = {
        src: url_o,
        type: 'bora-custom-slide',
        key: description._content,
        description: description._content,
        title: title,
        url: url_o,
        width: width_o,
        height: height_o,
        srcSet: []
      }
      let srcSetString = url_o + " " + width_o + "w, ";
      let sizes = width_o + "px, ";

      if (url_l) {
        srcSetString += url_l + " " + width_l + "w, ";
        sizes += width_l + "px, ";
        obj.srcSet.push({
          src: url_l,
          width: width_l,
          height: height_l
        })
      }
      if (url_m) {
        srcSetString += url_m + " " + width_m + "w, ";
        sizes += width_m + "px, ";
        obj.srcSet.push({
          src: url_m,
          width: width_m,
          height: height_m
        })
      }
      if (url_s) {
        srcSetString += url_s + " " + width_s + "w, ";
        sizes += width_s + "px, ";
        obj.srcSet.push({
          src: url_s,
          width: width_s,
          height: height_s
        })
      }
      if (url_t) {
        srcSetString += url_t + " " + width_t + "w";
        sizes += width_t + "px";
        obj.srcSet.push({
          src: url_t,
          width: width_t,
          height: height_t
        })
      }
      obj.srcSetString = srcSetString;
      obj.sizesString = sizes;
      return obj;
    })

    resolve({
      images: images,
      slides: slides
    });
  });
}

export async function getServerSideProps(context: any) {
  try {
    const { locale } = context;
    const { images, slides} = await  getImages(locale, 1, PAGE_SIZE);
    return {
      props: {
        ...(await serverSideTranslations(locale, ["common", "home"])),
        ...(await getShopNavigation(locale)), // makes "ShopNavigationColumn" property available on page props
        images,
        slides,
        locale,
        U19: false
      }
    };
  } catch (error) {
    console.error(error)
    return  redirectTo404Page();
  }
}

export default function GalleriesIndex(data: any) {

  const [images, setImages] = useState<Flickr | null>(data.images);
  let [locale, setLocale] = useState(data.locale);
  let [page, setPage] = useState(1);
  let [pageSize, setPageSize] = useState(PAGE_SIZE);
  let [searchString, setSearchString] = useState();
  let [slides, setSlides] = useState(data.slides);
  let [lightboxIndex, setLightboxIndex] = useState(-1);
  const [toggleFilter, setToggleFilter] = useState(false);
  const router = useRouter();
  const query = router.query;
  const [activeFilter, setActiveFilter]: any = useState(query?.category ?? '');

  const categories = [
    {name: 'Race Bike 2024 - Build Up', tag: 'Race_Bike_2024_Build_up'},
    {name: 'Vuelta a Espana 2023', tag: 'lavuelta23'},
    {name: 'Vuelta a Espana 2022', tag: 'lavuelta22'},
    {name: 'Giro d’Italia', tag: 'Giro23'},
    {name: 'Tour de France', tag: 'tdf2023'},
  ];

  async function previousPage() {
    page = page - 1;
    setPage(page);
    const {images, slides} = await getImages(locale, page, pageSize, null, activeFilter);
    setImages(images);
    setSlides(slides);
  }
  async function nextPage() {
    console.log("clicked next page");
    page = page + 1;
    setPage(page);
    console.log("page", page);
    const {images, slides} = await getImages(locale, page, pageSize, null, activeFilter);
    console.log("images", images);
    console.log("slides", slides);
    setImages(images);
    setSlides(slides);
  }
  async function searchImages() {
    page = 1;
    setPage(page);
    const {images, slides} = await getImages(locale, page, 10, searchString, activeFilter);
    setImages(images);
    setSlides(slides);
  }

  function changedSearchString(event: any) {
    setSearchString(event.target.value);
  }

  const handleClickDropdown = (event: any, filter: string) => {
    if (filter !== activeFilter) {
      console.log("test 1", event);
      setToggleFilter(true)
    } else {
      console.log("test 2", event);
      setToggleFilter(!toggleFilter)
    }
    setActiveFilter(filter)
  }

  const handleClick = async (event: any, filter: any) => {
    setImages(null);
    setSlides(null);
    if (filter !== activeFilter) {
      setToggleFilter(true)
    } else {
      setToggleFilter(!toggleFilter)
      filter = '';
    }
    setActiveFilter(filter);
    const { images, slides} = await getImages(locale, page, pageSize, searchString, filter)
    setImages(images);
    setSlides(slides);
  }

  const { t } = useTranslation("common");
  return (
    <>
      <div className="container-rg">
        <Header></Header>
        <div className={s.searchBar}>
          <label className="hidden" htmlFor={'search'}>
            {t("search")}
          </label>
          <input type="text"
                 value={searchString}
                 id={'search'}
                 className={s.input}
                 onChange={(e) => { changedSearchString(e) }}
                 placeholder={t("search-images")}
                 aria-label={t("search")} />
          <Button variant={"ghost"} onClick={(e) => { searchImages() }}>
            <svg className={s.icon} fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
              />
            </svg>
          </Button>
        </div>
        <main className={s.body}>
        <aside>
          <div className="relative inline-block w-full">
            <div className="lg:hidden">
              <span className="rounded-md shadow-sm">
                <button
                  type="button"
                  onClick={(e) => handleClickDropdown(e, 'categories')}
                  className="flex justify-between w-full rounded-sm border border-accent-3 px-4 py-3 bg-accent-0 text-sm leading-5 font-medium text-accent-4 hover:text-accent-5 focus:outline-none focus:border-blue-300 focus:shadow-outline-normal active:bg-accent-1 active:text-accent-8 transition ease-in-out duration-150"
                  id="options-menu"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  {activeFilter
                    ? `Category: ${activeFilter}`
                    :  t("all-categories") }
                  <svg
                    className="-mr-1 ml-2 h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </span>
            </div>
            <div
              className={`origin-top-left absolute lg:relative left-0 mt-2 w-full rounded-md shadow-lg lg:shadow-none z-10 mb-10 lg:block ${
                activeFilter !== 'categories' || toggleFilter !== true
                  ? 'hidden'
                  : ''
              }`}
            >
              <div className="rounded-sm bg-accent-0 shadow-xs lg:bg-none lg:shadow-none">
                <div
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="options-menu"
                >
                  <ul>
                    <li
                      className={cn(
                        'block text-sm leading-5 text-accent-4 lg:text-base lg:no-underline lg:font-bold lg:tracking-wide hover:bg-accent-1 lg:hover:bg-transparent hover:text-accent-8 focus:outline-none focus:bg-accent-1 focus:text-accent-8',
                        {
                          underline: !activeFilter,
                        }
                      )}
                    >
                      <Link legacyBehavior
                            href={{ pathname: '' }}
                      >
                        <a
                          onClick={(e) => handleClick(e, null)}
                          className={
                            'block lg:inline-block px-4 py-2 lg:p-0 lg:my-2 lg:mx-4'
                          }
                        >
                          {t("all-categories")}
                        </a>
                      </Link>
                    </li>
                    {categories.map((cat) => (
                      <li
                        key={cat.name}
                        className={cn(
                          'block text-sm leading-5 text-accent-4 hover:bg-accent-1 lg:hover:bg-transparent hover:text-accent-8 focus:outline-none focus:bg-accent-1 focus:text-accent-8',
                          {
                            underline: activeFilter === cat.tag,
                          }
                        )}
                      >
                        <Link legacyBehavior
                              href={{
                                pathname: '',
                              }}
                        >
                          <a
                            onClick={(e) => handleClick(e, cat.tag)}
                            className={
                              'block lg:inline-block px-4 py-2 lg:p-0 lg:my-2 lg:mx-4'
                            }
                          >
                            {cat.name}
                          </a>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </aside>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-2">
          { images?.photos && images.photos.photo.map((image: Photo, index: any) => {
            return <div className={s.galleryImageContainer} onClick={() => setLightboxIndex(index)} key={index}>

              <Image
                className="aspect-square object-cover line-height-1 hover:scale-105 transition-transform duration-500"
                src={image.url_m}
                alt={image.description?._content}
                width={450}
                height={450}
                priority={index}
                quality="85"
              />
              <span className="absolute left-0 bg-black text-white truncate w-full p-2">{image.title}</span>
            </div>
          })}
          <Lightbox
            open={lightboxIndex >= 0}
            index={lightboxIndex}
            close={() => setLightboxIndex(-1)}
            slides={slides}
            render={{
              slide: (slide: any) =>
                <CustomLightbox slide={slide} />
            }}
          />
        </div>
        </main>
        <div className="text-center my-6">
          {
            images &&
            <div>
              <Button className="mr-3"
                      variant={'ghost'}
                      onClick={(e) => { previousPage() }}
                      disabled={page === 1}>
                {t("previous")}
              </Button>
              <Button variant={'ghost'}
                      onClick={(e) => { nextPage() }}
                      disabled={images.photos.page * images.photos.perpage >= images.photos.total}>
                {t("next")}
              </Button>
            </div>
          }
        </div>
      </div>
    </>
  )
}

GalleriesIndex.Layout = Layout
